import { useState, useEffect } from 'react';
import { Box, BoxProps } from '@chakra-ui/react';

type FadeInProps = BoxProps & {
   after: number;
};

export function FadeIn({ after, children, ...props }: FadeInProps) {
   const [shouldShow, setShouldShow] = useState(false);

   useEffect(() => {
      const timeout = setTimeout(() => {
         setShouldShow(true);
      }, after);
      return () => clearTimeout(timeout);
   }, []);

   return (
      <Box opacity={shouldShow ? 1 : 0} transition="opacity 1s" {...props}>
         {children}
      </Box>
   );
}
